import api from '../api';

export function listAccounts() {
    return api.get('/accounts').then(response => response.data);
}

export function updateDetails(accountId, name, website, timezone) {
    return api.post(`/accounts/${accountId}/update-details`, {
        'name': name,
        'website': website,
        'timezone': timezone
    });
}
